<template>
  <v-app>
    <v-main>
      <v-container fluid class="fill-height">
        <v-row>
          <v-col cols="12" class="text-center">
            <v-img src="@/assets/images/logos/logo-vertical.png" width="250" class="mx-auto"></v-img>
            <h1 class="display-1">Error 404</h1>
            <p class="subtitle-1">Página no encontrada</p>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn color="primary" @click="goHome">Volver al inicio</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "ErrorLayout",
  methods: {
    goHome() {
      this.$router.push("/");
    },
  },
});
</script>

<style scoped>
</style>
